// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "controllers"
import "@hotwired/turbo-rails"
import {Application} from "stimulus"
import Flatpickr from "stimulus-flatpickr";
import {definitionsFromContext} from "stimulus/webpack-helpers"
import "../components"

// import LocalTime from "local-time"


const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

function importAll(r) {
  r.keys().forEach(r)
}

importAll(require.context("../../components", true, /[_\/]component\.js$/))

Rails.start()
Turbolinks.start()
ActiveStorage.start()
// LocalTime.start()

require("@hotwired/turbo-rails")
require("toastr/toastr")
require("flatpickr/dist/flatpickr.css")
require("select2/dist/css/select2.css")
require('select2')

application.register('flatpickr', Flatpickr)

$(document).on('change', 'input[type="file"]', function (ev) {
  let $cf;
  $cf = $(this).parents('div.file');
  if ($cf.find('span.file-name').length > 0) {
    $cf.find('span.file-name').text(ev.target.files[0].name);
  } else {
    $cf.find('span.file-label').text(ev.target.files[0].name);
  }
  if ($cf.find('span.file-length').length > 0) {
    return $cf.find('span.file-length').text(ev.target.files.length + " file chosen");
  }
});

require("trix")
require("@rails/actiontext")